import React, { Component } from 'react'
import i18n from 'i18next'
import Select from '../form/Select'

class ScopeSelector extends Component {
    constructor(props) {
        super(props)
        this.state = {
            scopeOptions: [],
            selectValue: undefined,
        }
    }

    componentDidMount() {
        this.getInitialOptions()
    }

    formatOptions = (o, nestedLevel = 1) => {
        let childOptions
        let finalChildOptions
        if (o.children && o.children.length && o.children[0].scope === 'product') {
            finalChildOptions = {
                options: o.children.map((c) => (
                    { ...c, value: c.productId, nestedLevel: nestedLevel + 1 }
                )),
            }
        }
        if (o.children && o.children.length) {
            childOptions = o.children.map((co) => this.formatOptions(co, nestedLevel + 1))
        }
        return [{
            options: [{
                value: o.productId || o.portfolioId || o.divisionId,
                scope: o.scope,
                label: o.label,
                nestedLevel,
            }],
        }, finalChildOptions || childOptions || { options: [] }]
    }

    getInitialOptions = async () => {
        const { appStore, DynamicDashboardStore, initialScope } = this.props
        const { scopeSelectorData } = DynamicDashboardStore
        const { userData } = appStore
        const { role } = userData
        const initialScopes = [100, 110, 150].includes(role)
            ? [{ label: 'Company', value: appStore.userData.clientId, scope: 'client' }]
            : []
        const scopeOptions = scopeSelectorData.reduce((options, o) => {
            options.push(this.formatOptions(o))
            return options
        }, initialScopes).flat(3)

        const initScope = scopeOptions
            .map((o) => (o.options ? o.options : o))
            .flat(2)
            .find((o) => o.value === initialScope)
            || scopeOptions[0].value

        this.setState({
            scopeOptions,
            selectValue: initScope,
        })
    }

    scopeChange = (value) => {
        const { history, DynamicDashboardStore } = this.props
        const { editing, updateConfirmationModal } = DynamicDashboardStore
        const confirmationSettings = {
            show: editing,
            onFalse: () => { DynamicDashboardStore.confirmationModal.show = false },
            title: i18n.t('dashbaords.unsavedChanges.title'),
            description: i18n.t('dashbaords.unsavedChanges.description'),
        }
        if (value.scope === 'client') {
            if (!editing) {
                history.push('?')
                DynamicDashboardStore.init(true)
                DynamicDashboardStore.setScopeInfo(value)
                this.setState({ selectValue: value })
                return
            }
            confirmationSettings.onTrue = () => {
                history.push('?')
                DynamicDashboardStore.init(true)
                this.setState({ selectValue: value })
                DynamicDashboardStore.setScopeInfo(value)
                DynamicDashboardStore.editing = false
                updateConfirmationModal({ show: false })
            }
            updateConfirmationModal(confirmationSettings)
        } else {
            if (!editing) {
                history.push(`?${value.scope}Id=${value.value}`)
                DynamicDashboardStore.init()
                DynamicDashboardStore.setScopeInfo(value)
                this.setState({ selectValue: value })
                return
            }

            confirmationSettings.onTrue = () => {
                history.push(`?${value.scope}Id=${value.value}`)
                DynamicDashboardStore.init()
                DynamicDashboardStore.setScopeInfo(value)
                this.setState({ selectValue: value })
                DynamicDashboardStore.editing = false
                updateConfirmationModal({ show: false })
            }
            updateConfirmationModal(confirmationSettings)
        }
        DynamicDashboardStore.setBreadcrumbs()
    }

    render() {
        const {
            scopeOptions,
            selectValue,
        } = this.state

        if (!scopeOptions.length) return null

        return (
            <div className="scopeSelector">
                <div className="scopeIndicator">{i18n.t('dashboards.selector.dashboardLevel')}</div>
                <Select
                    options={scopeOptions}
                    value={selectValue}
                    onBlur={this.scopeChange}
                    elClass="indented"
                    indentation
                    showSelected
                    cssClass="selector"
                    classNamePrefix="dropdown"
                    className="exploriDropdown indented"
                    // styles={{
                    //     option: (provided, state) => ({
                    //         ...provided,
                    //         padding: `2px 8px 2px ${state.data.nestedLevel * 12}px !important;`,
                    //     }),
                    // }}
                />
            </div>
        )
    }
}

export default ScopeSelector
